// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"jgp-1rFBi","closeIcon":"jgp-R_HJt","title":"jgp-26t-r"};